import React from "react";
import "./css/PoliciesPages.css";

const Terms = () => (
  <div className="policies-container">
    <div className="policies-content">
      <div className="policies-header">
        <h1 className="policies-title">Terms of Service</h1>
        <p className="policies-date">
          <strong>Effective Date:</strong> May 12, 2026
        </p>
      </div>

      <p className="policies-intro">
        By using TasteBuds Social, you agree to these terms.
      </p>

      <section className="policy-section">
        <h2>User Content</h2>
        <ul>
          <li>
            You retain ownership of your posted content (reviews, photos, etc.).
          </li>
          <li>
            By posting, you grant us a license to display and distribute your
            content within the service.
          </li>
          <li>
            You are responsible for ensuring you have rights to any content you
            upload.
          </li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>Prohibited Conduct</h2>
        <ul>
          <li>No unlawful, abusive, or harassing content</li>
          <li>No malicious software or unauthorized access</li>
          <li>No scraping or copying platform data without permission</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>Content Moderation</h2>
        <p>We may remove content or suspend users who violate these terms.</p>
      </section>

      <section className="policy-section">
        <h2>Availability</h2>
        <p>
          The service is provided "as is" and "as available" without warranties
          of any kind. We do not guarantee uninterrupted or error-free
          operation.
        </p>
      </section>

      <section className="policy-section">
        <h2>Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, TasteBuds Social shall not be
          liable for indirect damages, lost profits, data loss, service
          interruptions, or user-generated content.
        </p>
      </section>

      <section className="policy-section">
        <h2>Termination</h2>
        <p>
          We may suspend or terminate access to the service at our discretion if
          these Terms are violated.
        </p>
      </section>

      <section className="policy-section">
        <h2>Privacy</h2>
        <p>
          Your use of the service is also governed by our{" "}
          <a href="/privacy">Privacy Policy</a>.
        </p>
      </section>

      <section className="policy-section">
        <h2>Changes to Terms</h2>
        <p>
          We may modify these Terms from time to time. Continued use of the
          service constitutes acceptance of updated Terms.
        </p>
      </section>

      <section className="policy-section last-section">
        <h2>Contact</h2>
        <p>
          TasteBuds Social
          <br />
          support@tastebuds.social
          <br />
          tastebuds.social
        </p>
      </section>
    </div>
  </div>
);

export default Terms;
